module.exports = __webpack_public_path__ + "static/media/cart-notice.ce38d7a9.png";